/* global AFRAME */

/**
 * Component that listens to an event, fades out an entity, swaps the texture, and fades it
 * back in.
 */
 
  
  
   var global_webvr_adidas = 
   {  
		timer: 0,
		lastUpdate: Date.now()
   };

